import React, { useContext } from 'react';
import { string, arrayOf, func, bool } from 'prop-types';
import classNames from 'classnames/bind';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Drawer, DrawerItem, DrawerHeader } from '@thd-olt-component-react/drawer';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { CarouselHeader } from '../core/CarouselHeader';
import { getSkippers } from '../utils/helpers';
import { supplementalRecsdataModel } from '../dataModel';
import styles from './SupplementalRecs.module.scss';
import { SupplementalProductPodV7 } from './SupplementalProductPodV7';

const cx = classNames.bind(styles);

const SupplementalRecsPods = ({
  productsData, schemaName, storeId, zipCode, handleViewDetailsClick, podTitle, isDrawerOpen
}) => {

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel !== 'desktop';
  const drawerWidth = isMobile ? 100 : 500;
  const defaultVariables = {
    storeId,
    zipCode,
    ...getSkippers({})
  };
  const title = podTitle || 'Shop the Look';
  const analyticsParent = 'supplemental-recs';

  return (
    <>
      {
        productsData?.length
        && (
          <Drawer
            id={schemaName}
            open={isDrawerOpen}
            isMobile={isMobile}
            position="right"
            initialItem="recommendations-quick-view"
            maxSize={drawerWidth}
            onClose={handleViewDetailsClick}
          >
            <DrawerItem name="recommendations-quick-view">
              <DrawerHeader>
                <CarouselHeader title={title} />
              </DrawerHeader>
              <div className={cx('supplemental-recs__drawer-item-wrapper')}>
                <QueryProvider
                  dataSource={schemaName}
                  cacheKey={`${schemaName}-supplemental-recs-products`}
                  defaultVariables={defaultVariables}
                >
                  {
                    productsData.map((prod, idx) => {
                      return (
                        <SupplementalProductPodV7
                          key={prod?.product.itemId}
                          itemId={prod?.product.itemId}
                          brandTitleMaxLine={3}
                          showDisabledATC
                          hideSavingsText
                          storeId={storeId}
                          position={idx}
                          parent={analyticsParent}
                          scheme={schemaName}
                        />
                      );
                    })
                  }
                </QueryProvider>
              </div>
            </DrawerItem>
          </Drawer>
        )
      }
    </>
  );
};

SupplementalRecsPods.propTypes = {
  isDrawerOpen: bool,
  productsData: arrayOf(Object),
  storeId: string.isRequired,
  zipCode: string.isRequired,
  schemaName: string.isRequired,
  handleViewDetailsClick: func.isRequired,
  podTitle: string
};

SupplementalRecsPods.defaultProps = {
  isDrawerOpen: false,
  productsData: null,
  podTitle: null
};

SupplementalRecsPods.dataModel = supplementalRecsdataModel;
SupplementalRecsPods.displayName = 'SupplementalRecs';

export { SupplementalRecsPods };
